module.exports = __webpack_public_path__ + "img/center-sample_faceberry.751f5d4c.png";